<template>
    <div class="loading-panel text-center mt-4">
        <b-spinner v-if="status == 0" class="loading-spinner" variant="dark"></b-spinner>
        <div style="width: 50%" class="mx-auto loading-failed" v-if="status == -1">
            Gagal terhubung ke server.<br />
            <b-btn class="mt-2" variant="primary" @click="$emit('init')">Coba lagi</b-btn>
        </div>
    </div>
</template>

<script>
export default {
    name: 'loading-widget',
    props: {
        status: { type: Number, required: true }
    }
}
</script>